import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { SelectedItems } from '@components/common/SelectedItems'
import { StatusTag } from '@components/common/StatusTag'
import { VisuallyHiddenInput, useMediaQueryContext } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import { pluralize } from '@fourthwall/utils/dist/string'

import * as S from './styled'
import type { SelectedProductsProps } from './types'

export const SelectedProducts = ({
  name,
  addItemsButtonLabel = 'Add products',
  header,
  productsCount,
  onAddProducts,
  onRemoveProduct,
  renderItem,
  ...props
}: SelectedProductsProps) => {
  const media = useMediaQueryContext()

  const defaultHeader = (
    <>
      {productsCount || 'No'} {pluralize(productsCount, 'product')} added
    </>
  )

  const defaultRenderItem = (product: Offer.Item) => (
    <>
      <PhotoThumbnail
        url={product.primaryImage?.thumbnail.url}
        size={media.laptop ? 'large' : 'medium'}
      />
      <S.ProductDetails>
        <div>{product.name}</div>
        <StatusTag status={product.state.status} isSoldOut={!product.state.available} />
      </S.ProductDetails>
    </>
  )

  return (
    <>
      {name && <VisuallyHiddenInput name={name} />}
      <SelectedItems
        header={header || defaultHeader}
        itemsCount={productsCount}
        addItemsButtonLabel={addItemsButtonLabel}
        renderItem={renderItem || defaultRenderItem}
        onAddItems={onAddProducts}
        onRemoveItem={(product: Offer.Item) => onRemoveProduct(product.id)}
        {...props}
      />
    </>
  )
}
